import React from 'react';
import { Container, Row,Col, Card, Alert, Button, Modal } from "react-bootstrap";
import { useParams, useNavigate } from 'react-router-dom';
import Input from '../components/Input';
import axios from '../axiosInterceptor';

function ResetPasswordToken() {

    const navigate = useNavigate();
    const { token } = useParams();

    const [show, set_show] = React.useState(false);
    const [error, set_error] = React.useState({ hidden:true, message:"" });

    const [form,set_form] = React.useState([
        { name:"password",value:"",valid:false },
        { name:"password_confirm",value:"",valid:false }
    ]);

    const hide_modal = () => {
        set_show(()=> false);
        navigate('/login');
    }

    const on_change = (e,valid) => {
        
        set_form((prev_form)=>{

            let new_form = prev_form.map((item)=>{
                if(item.name === e.target.name){
                    item.value = e.target.value;
                    item.valid = valid;
                }
                return item;
            });

            return new_form;
        });

    }

    const on_submit = () => {

        if(form[0].valid && form[1].valid){
            console.log('Formulario válido');

            axios.post(`/auth/reset-password`,{ password:form[0].value },{
                headers:{
                    "Token-Reset-Password":token
                }
            }).then(()=>{
                set_show(()=> true);
            })
            .catch((error)=>{

                set_error(()=> {return { hidden:false, message:error.message }})
                console.log('Error',error);
            })
        }
    }

  return (
    <Container className='mt-4'>
        <Row className='justify-content-center'>
            <Col xs='10' sm='8' md='8' lg='5' xl='4'>
                <Card>
                    <Card.Body>
                        <Card.Title className='text-center mb-4'>Restablecer Contraseña</Card.Title>
                        <Alert key={'primary'} variant={'primary'}>
                            Introduce tu nueva contraseña.
                        </Alert>

                        <Input 
                            label='Nueva Contraseña' 
                            name='password'
                            type='password' 
                            placeholder='Ingrese su nueva contraseña'
                            required={true}
                            onChange={on_change}
                        />

                        <div className='p-2'></div>

                        <Input 
                            label='Confirmar Contraseña' 
                            name='password_confirm'
                            type='password' 
                            placeholder='Ingrese la confirmación de su nueva contraseña'
                            required={true}
                            compare={'password'}
                            onChange={on_change}
                        />


                        <Alert hidden={error.hidden} key={'danger'} variant={'danger'}>
                            {error.message}
                        </Alert>
                        <Button onClick={on_submit} variant="primary" className='mt-3' style={{display:"table",marginLeft:"auto",marginRight:"auto"}}>Resetear Contraseña</Button>
                    </Card.Body>
                </Card>
            </Col>
        </Row>

        <Modal show={show} onHide={hide_modal}>
        <Modal.Header closeButton>

          <Modal.Title>Exito</Modal.Title>

        </Modal.Header>

        <Modal.Body>La contraseña ha sido actualizada correctamente.</Modal.Body>
        <Modal.Footer>

          <Button variant="secondary"  onClick={hide_modal}> Aceptar </Button>

        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default ResetPasswordToken